import React from "react";
import { NO_DATA_MESSAGE } from "../../app_constants";

const SIZE_CLASSES = {
  default: "error",
  medium: "error error--medium",
  big: "error error--big"
};

function NoData({ message = NO_DATA_MESSAGE, size = "default", customStyles = {} }) {
  return (
    <p className={SIZE_CLASSES[size] ?? ""} style={customStyles}>
      {message}
    </p>
  );
}

export default NoData;
